import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

const Nudge = ({ to, count, title, testid }) => (
        <Link to={to} data-testid={testid}
        className="mt-4 first:mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4 rounded-2xl border border-amber-200 bg-amber-50 px-6 py-4 hover:bg-amber-100 transition-colors dark:bg-amber-500/10 dark:border-amber-500/30 dark:hover:bg-amber-500/15">
        <div className="flex items-center gap-4">
            <AlertTriangle className="w-5 h-5 text-amber-700 dark:text-amber-400 shrink-0" />
            <div>
                <div className="font-medium text-[#0F172A] dark:text-amber-100" data-testid={`${testid}-count`}>{count} staff {count === 1 ? "has" : "have"} no {title}</div>
                <div className="text-sm text-[#475569] dark:text-amber-200/70">They show as "Unassigned" on reports. Fix them in one place.</div>
            </div>
        </div>
        <span className="inline-flex items-center gap-1 text-sm text-amber-800 dark:text-amber-300 font-medium whitespace-nowrap">Assign now <ArrowUpRight className="w-4 h-4" /></span>
    </Link>
);

// Dashboard nudges: show only when some staff have no department / division.
export const MissingDeptCard = () => {
    const [counts, setCounts] = useState({ dept: 0, div: 0 });

    useEffect(() => {
        api.get("/employees-missing-department")
            .then(({ data }) => setCounts({ dept: data?.count || 0, div: data?.missing_division_count || 0 }))
            .catch(() => {});
    }, []);

    if (!counts.dept && !counts.div) return null;
    return (
        <div>
            {counts.dept > 0 && <Nudge to="/missing-departments" count={counts.dept} title="department" testid="missing-dept-card" />}
            {counts.div > 0 && <Nudge to="/bulk-divisions" count={counts.div} title="division" testid="missing-div-card" />}
        </div>
    );
};

export default MissingDeptCard;
